import axios, { AxiosResponse } from 'axios';
import { ApiResponse } from '../api.types';
import {
  ChangePasswordRequest,
  CreateUserRequest, ListAllUsersResponse, LoginModel, TableauTokenResponse, UserPermissionGroupModel, UserResponse
} from './authentication.types';

const API_URL = window.config.apiUrls.frontendServerApi;

const login = async (
  request: { username: string; password: string }
) => {
  const { data }: AxiosResponse<ApiResponse<LoginModel>> = await axios.post(
    `${API_URL}/user/login`,
    { ...request }
  );
  return data.data;
};

const logout = async () => {
  await axios.post(`${API_URL}/user/logout`, {});
  return true;
};

const validateToken = async () => {
  await axios.get(`${API_URL}/user`);
};

const renewToken = async (userId: string) => {
  const { data }: AxiosResponse<ApiResponse<LoginModel>> = await axios.post(`${API_URL}/user/renew/${userId}`);

  return data.data;
};

const listUsers = async (): Promise<ListAllUsersResponse> => {
  const { data }: AxiosResponse<ApiResponse<ListAllUsersResponse>> = await axios.get(`${API_URL}/user/:supplier/manage`);

  return data.data;
};


const getUserByEmail = async (userLogin: string): Promise<UserResponse> => {
  const { data }: AxiosResponse<ApiResponse<UserResponse>> = await axios.get(`${API_URL}/user/:supplier/manage/${userLogin}`);

  return data.data;
};

const createUser = async (request: CreateUserRequest): Promise<UserResponse> => {
  const { data }: AxiosResponse<ApiResponse<UserResponse>> = await axios.post(`${API_URL}/user/:supplier/manage`,
    request);

  return data.data;
};

const getPermissionGroups = async (): Promise<UserPermissionGroupModel[]> => {
  const { data }: AxiosResponse<ApiResponse<UserPermissionGroupModel[]>> = await axios.get(`${API_URL}/user/permission-groups`);

  return data.data;
};

const deleteUserCommand = async (userLogin: string) => {
  await axios.delete(`${API_URL}/user/:supplier/manage/${userLogin}`);
};

const editUser = async (request: CreateUserRequest, userLogin: string): Promise<UserResponse> => {
  const { data }: AxiosResponse<ApiResponse<UserResponse>> = await axios.put(`${API_URL}/user/:supplier/manage/${userLogin}`,
    request);

  return data.data;
};

const requestPasswordReset = async (loginInfo: string) => {
  await axios.post(
    `${API_URL}/public/user`, {}, { params: { login: loginInfo } }
  );
};

const resetPassword = async (changePasswordId: string, request: ChangePasswordRequest) => {
  await axios.post(
    `${API_URL}/public/user/${changePasswordId}`,
    request
  );
};

const getTableauToken = async (supplierCode: string) => {
  const data: AxiosResponse<ApiResponse<TableauTokenResponse>> = await axios.get(
    `${API_URL}/tableau/${supplierCode}`
  );

  return data.data.data.token;
};

const api = {
  authentication: {
    login,
    logout,
    validateToken,
    renewToken
  },
  user: {
    listUsers,
    getUserByEmail,
    createUser,
    getPermissionGroups,
    deleteUserCommand,
    editUser
  },
  password: {
    requestPasswordReset,
    resetPassword
  },
  tableau: {
    getTableauToken
  }
};

export default api;
